import { ROUTES } from "@habity/constants";
import { CategoryType, NestedHome, NestedProject } from "@habity/types";

export const isSearchRoute = (pathname: string | null) => {
  if (!pathname) return false;
  const searchPaths = [
    ROUTES.SEARCH.HOMES,
    ROUTES.SEARCH.BUYERS,
    ROUTES.SEARCH.BROKERS,
    ROUTES.SEARCH.AREAS,
    ROUTES.SEARCH.MUNICIPALITIES,
    ROUTES.SEARCH.PLACES,
    ROUTES.SEARCH.PROJECTS,
  ];
  return searchPaths.some((path) => pathname == path);
};

// TODO: This should probably include all the other types of profiles?
export const isProfileRoute = (pathname: string) =>
  pathname.includes(ROUTES.PROFILES.HOMES);

export const isVerificationRoute = (pathname: string) =>
  pathname === ROUTES.VERIFY;

export const isProtectedRoute = (pathname: string) =>
  pathname.startsWith(ROUTES.DASHBOARD.INDEX) ||
  pathname.startsWith(ROUTES.CLAIM) ||
  pathname.startsWith(ROUTES.VERIFY);

export const getCategorySearchRoute = (categories: CategoryType[]) => {
  const params: string[] = [];
  categories.map((c) => params.push(`categories=${c}`));
  return `${ROUTES.ROOT}?${params.join("&")}`;
};

export const getStreetViewUrl = (
  latitude: number | null,
  longitude: number | null
) => {
  if (!latitude || !longitude) return null;
  return `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${latitude},${longitude}`;
};

export const getMapsUrl = ({ zip, city, street }: { zip?: string; city?: string; street?: string }) => {
  return `https://maps.google.com/maps?q=${street}+${zip || ""}+${city || ""
    }&z=14`;
};

export const getMapsQueryUrl = (home: NestedHome) => {
  const { zip, city, street } = home.address || {};
  return `https://maps.google.com/maps?q=${street}+${zip || ""}+${city || ""
    }&z=14`;
};

export const getMapsQueryUrlForProject = (project: NestedProject) => {
  const { area } = project || {};
  const { name } = area || {};
  return `https://maps.google.com/maps?q=${name || ""}&z=14`;
};

export const getMapsPlaceUrl = (home: NestedHome) => {
  const { longitude, latitude } = home.address || {};
  return `https://www.google.com/maps/place/${latitude},${longitude}`;
};

export const stripQueryStringAndHashFromPath = (url: string) => {
  return url.split("?")[0].split("#")[0];
};

export const parseIdFromPath = (slug: string | string[] | undefined) => {
  if (typeof slug === "string") {
    const cleanedSlug = stripQueryStringAndHashFromPath(slug);
    const slugArr = cleanedSlug.split("-");
    return slugArr[slugArr.length - 1];
  }
  return null;
};

export const slugMissing = (slug?: string[] | string) => {
  return slug && !Array.isArray(slug) && !slug.includes("-");
};
